export function RedirectFailed() {
  return (
    <p
      className={`
        text-sm text-slate-500
        system-dark:text-zinc-400
      `}
    >
      Could not redirect automatically
    </p>
  );
}
